// import ReactApexChart  from 'react-apexcharts'
import { Box, Typography, Stack } from '@mui/material';
import { ArrowCircleUpRounded } from '@mui/icons-material';
import { AreaChart, Area, XAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

// Example data from the API
// const exampleData = {
//   attendanceStatData: {
//     recentSundayCount: 0,
//     attendancePercentage: 0,
//     monthOnMonthAttendance: [
//       {
//         month: 10,
//         year: 2023,
//         count: 0,
//       },
//       {
//         month: 11,
//         year: 2023,
//         count: 0,
//       },
//       {
//         month: 12,
//         year: 2023,
//         count: 0,
//       },
//       {
//         month: 1,
//         year: 2024,
//         count: 0,
//       },
//       {
//         month: 2,
//         year: 2024,
//         count: 19,
//       },
//       {
//         month: 3,
//         year: 2024,
//         count: 0,
//       },
//     ],
//   },
// };

// Function to map month index to month name
const getMonthName = (monthIndex) => {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  return months[monthIndex - 1]; // Subtracting 1 to match the array index
};

const OverViewChart = ({ aspect, attendanceStatData }) => {
  let data = [];

  if (attendanceStatData && attendanceStatData.monthOnMonthAttendance) {
    data = attendanceStatData.monthOnMonthAttendance.map((entry) => ({
      name: `${getMonthName(entry.month)} ${entry.year}`,
      'Total Attendance': entry.count,
    }));
  } else {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    const exampleData = {
      attendanceStatData: {
        monthOnMonthAttendance: [
          {
            month: currentMonth - 5 <= 0 ? currentMonth + 7 : currentMonth - 5,
            year: currentMonth - 5 <= 0 ? currentYear - 1 : currentYear,
            count: 0,
          },
          {
            month: currentMonth - 4 <= 0 ? currentMonth + 8 : currentMonth - 4,
            year: currentMonth - 4 <= 0 ? currentYear - 1 : currentYear,
            count: 0,
          },
          {
            month: currentMonth - 3 <= 0 ? currentMonth + 9 : currentMonth - 3,
            year: currentMonth - 3 <= 0 ? currentYear - 1 : currentYear,
            count: 0,
          },
          {
            month: currentMonth - 2 <= 0 ? currentMonth + 10 : currentMonth - 2,
            year: currentMonth - 2 <= 0 ? currentYear - 1 : currentYear,
            count: 0,
          },
          {
            month: currentMonth - 1 <= 0 ? currentMonth + 11 : currentMonth - 1,
            year: currentMonth - 1 <= 0 ? currentYear - 1 : currentYear,
            count: 0,
          },
          { month: currentMonth, year: currentYear, count: 0 },
        ],
      },
    };

    data = exampleData.attendanceStatData.monthOnMonthAttendance.map((entry) => ({
      name: `${getMonthName(entry.month)} ${entry.year}`,
      'Total Attendance': entry.count,
    }));
  }

  return (
    <Box
      p={4}
      flex={2}
      bgcolor="#fcfcfc"
      id="chart"
      display="flex"
      flexDirection="column"
      borderRadius="15px"
      boxShadow="2px 4px 10px 1px rgba(201,201,201,0.47)"
      width={{ xs: '100%' }}
    >
      <Typography fontSize={18} fontWeight={600} color="#808191">
        Attendance Within Last 6 Months
      </Typography>

      {/* <Stack my="10px" direction="row" gap={4} flexWrap="wrap">
        <Typography fontSize={23} fontWeight={700} color="#585858">
          536,335 Overall Members
        </Typography>
        <Stack direction="row" alignItems="center" gap={1}>
          <ArrowCircleUpRounded sx={{ fontSize: 25, color: '#000080' }} />
          <Stack>
            <Typography fontSize={15} color="#000080">
              {20}%
            </Typography>
            <Typography fontSize={12} color="#808191">
              Than Initial Volume
            </Typography>
          </Stack>
        </Stack>
      </Stack> */}

      <ResponsiveContainer width="100%" aspect={aspect}>
        <AreaChart width={730} height={340} data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="total" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#8884d8" stopOpacity={1} />
              <stop offset="95%" stopColor="#000080" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis dataKey="name" />
          <CartesianGrid strokeDasharray="3 3" className="gridChat" />
          <Tooltip />
          <Area type="monotone" dataKey="Total Attendance" stroke="#585858" fillOpacity={1} fill="url(#total" />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default OverViewChart;
